import { useTranslation } from "react-i18next"

import TextArea from "../../../../../../../Components/Input/TextArea"
import { tLiteral } from "../../../utils/questionText"

import styles from "../questionField.module.less"

const TextAreaControl = ({ question, value, status, onChange, onTouch }) => {
  const { t } = useTranslation()
  return (
    <div className={styles.textareaWrap}>
      <TextArea
        value={value ?? ""}
        placeholder={tLiteral(t, question.placeholder)}
        maxLength={question.max}
        showCount={!!question.max}
        rows={4}
        onChange={(e) => onChange(e.target.value)}
        onBlur={onTouch}
        status={status}
      />
    </div>
  )
}

export default TextAreaControl
